const theme = {
    fontFamily: 'Fira Sans'
};

export default theme;